<template>
  <section class="container pb-5">
    <section class="row mb-2 mb-md-5">
      <div class="col-12">
        <h1 class="text-center">
          Vos parrainages
        </h1>
      </div>
    </section>
    <v-invitation />
    <section class="row mt-4">
      <div class="col-12">
        <h2 class="text-blue-700 ">
          Cagnotte et filleuls
        </h2>
        <p>
          Vous avez actuellement {{ sponsorAccumulatedValue }} € sur votre cagnotte,
          Utilisez-le lors de votre prochaine souscription ou lors d’un renouvellement
          pour bénéficier d’une réduction sur votre contrat !
        </p>
      </div>
      <div class="my-2 col-12 col-md-4">
        <div
          class="card shadow"
          style="min-height:300px"
        >
          <div
            class="card-body d-flex p-4 transition-shadow rounded-4
            box-shadow-yellow-300 box-shadow-hover-yellow-300"
          >
            <div class="d-flex flex-column justify-content-between w-100">
              <div class="mx-auto">
                <h3> votre cagnotte</h3>
                <p>la cagnotte est  déduite de votre cotisation</p>
              </div>
              <div
                class="d-flex bg-green-300 cursor-pointer mx-auto mb-3 text-center align-items-center justify-content-center rounded-4"
                style="width: 140px; height: 70px"
              >
                <h1 class="m-0">
                  {{ sponsorAccumulatedValue }} €
                </h1>
              </div>
              <button
                class="btn btn-primary w-100"
                type="button"
                @click="clipboardCopy"
              >
                <div class="d-flex flex-row">
                  <div class="ms-auto me-1">
                    Utiliser Ma cagnotte
                  </div>
                  <v-icon
                    icon="arrow-white-right"
                    class="me-auto"
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
        <input
          id="promoCode"
          type="text"
          :value="promoCode"
          style="position:absolute; z-index:-1;top:0;"
          readonly
        >
      </div>
      <div class="my-2 col-12 col-md-8">
        <div
          class="card shadow"
          style="min-height:300px"
        >
          <div
            class="card-body d-flex p-4 transition-shadow rounded-4
            box-shadow-pink-300 box-shadow-hover-pink-300"
          >
            <div
              class="d-flex flex-column w-100"
              :class="{'justify-content-between mx-auto' : sponsoredChildren.length === 0}"
            >
              <div class="mx-auto">
                <h5>Vos filleuls</h5>
              </div>
              <template v-if="sponsoredChildren.length > 0">
                <v-card-line
                  v-for="(sponsored, index) in sponsoredChildren"
                  :key="sponsored.firstName + sponsored.lastName + index"
                  v-bind="sponsored"
                  class="my-2"
                />
              </template>
              <template v-else>
                <div class="d-flex mx-auto">
                  <img
                    :src="`${aws}/unicorn-fairy.png`"
                    width="130"
                    class="img-fluid"
                  >
                </div>
                <router-link
                  v-slot="{ navigate }"
                  to="/client/perks/sponsorship/email"
                  custom
                >
                  <button
                    type="button"
                    class="btn btn-primary w-100"
                    @click="navigate"
                  >
                    <div class="d-flex flex-row">
                      <div class="ms-auto me-1">
                        Nouveau filleul
                      </div>
                      <v-icon
                        icon="plus-white"
                        class="me-auto"
                      />
                    </div>
                  </button>
                </router-link>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
import { ui } from '@/mixins';
import SponsorshipInvite from '@/components/sponsorship/default/SponsorshipInvite.vue';
import SponsorshipCardChildren from '@/components/sponsorship/default/SponsorshipCardChildren.vue';

export default {
  name: 'ClientSponsorship',
  components: {
    'v-invitation': SponsorshipInvite,
    'v-card-line': SponsorshipCardChildren,
  },
  mixins: [ui],
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
    sponsorAccumulatedValue() {
      return this.$store.getters['sponsorship/pool'] || 0;
    },
    sponsoredChildren() {
      return this.$store.getters['sponsorship/referrals'];
    },
    promoCode() {
      return this.$store.getters['client/get'].email;
    },
  },
  mounted() {
    this.$store.dispatch('sponsorship/getSponsorships');
    this.$store.dispatch('sponsorship/getSponsorshipPool');
  },
  methods: {
    clipboardCopy() {
      const copyText = document.getElementById('promoCode');
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand('copy');
      this.ui_showToast({ show: true, message: 'Code promo copié !' });
    },
  },
};
</script>
